<div class="agent-body h-100 d-flex flex-column justify-content-between m-3">
  <div class="button-list">
    <button class="release-btn btn-accello-secondary" (click)="addNewRelease()">
      <img
        [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
        alt="Add Icon"
        width="18"
        height="18"
      />
      Add New Release
    </button>

    <button
      class="release-btn btn-accello-light"
      (click)="removeReleases()"
      [disabled]="!selectedReleases.length"
      (focus)="changeRemoveIcon(false)"
      (mouseenter)="changeRemoveIcon(false)"
      (mouseleave)="changeRemoveIcon(false)"
      (blur)="changeRemoveIcon(false)"
      (mousedown)="changeRemoveIcon(true)"
      (mouseup)="changeRemoveIcon(false)"
    >
      <img [src]="iconSrcDelete | assetUrl" alt="Reclaim Agent" width="18" height="18" />
      <!-- <img [src]="'images/release/remove-release.svg' | assetUrl" alt="Add Icon" width="18" height="18"> -->
      Remove Releases
    </button>
  </div>

  <app-loading *ngIf="isLoading" [text]="'Loading'" class="h-100"></app-loading>

  <div class="table-div h-100" *ngIf="!isLoading">
    <app-expandable-table
      [columns]="columns"
      [data]="releases"
      [options]="options"
      (handleActions)="handleActionsInTable($event)"
      (onRowSelect)="handleRowSelect($event)"
    ></app-expandable-table>
  </div>
</div>
